// extracted by mini-css-extract-plugin
export default {"container":"LoadingIcon_container__eiCMS","center":"LoadingIcon_center__5m4dO","wave":"LoadingIcon_wave__EVIc7"};